import AddressManager from './AddressManager'

export default AddressManager
